// Adapter lưu trữ khoá học. Phase B: localStorage; Phase C: API — giữ interface.
import type { CourseDoc } from '../types/CourseDoc'
import { slugify } from './id'

const KEY = 'course_builder_library_v1'

function readAll(): CourseDoc[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]')
  } catch {
    return []
  }
}

function writeAll(list: CourseDoc[]): void {
  localStorage.setItem(KEY, JSON.stringify(list))
}

function ensureSlug(doc: CourseDoc): CourseDoc {
  if (doc.slug) return doc
  return { ...doc, slug: slugify(doc.title) || doc.id }
}

export const courseStorage = {
  list(): CourseDoc[] {
    return readAll().sort((a, b) => (b.updatedAt || '').localeCompare(a.updatedAt || ''))
  },
  get(id: string): CourseDoc | null {
    return readAll().find((c) => c.id === id) || null
  },
  getBySlug(slug: string): CourseDoc | null {
    return readAll().find((c) => c.slug === slug) || null
  },
  save(doc: CourseDoc): CourseDoc {
    const now = new Date().toISOString()
    const list = readAll()
    const withSlug = ensureSlug(doc)
    const i = list.findIndex((c) => c.id === withSlug.id)
    const updated: CourseDoc = { ...withSlug, updatedAt: now, createdAt: withSlug.createdAt || now }
    if (i >= 0) list[i] = updated
    else list.push(updated)
    writeAll(list)
    return updated
  },
  remove(id: string): void {
    writeAll(readAll().filter((c) => c.id !== id))
  },
  publish(id: string): CourseDoc | null {
    const list = readAll()
    const i = list.findIndex((c) => c.id === id)
    if (i < 0) return null
    list[i] = { ...list[i], status: 'published', updatedAt: new Date().toISOString() }
    writeAll(list)
    return list[i]
  },
}
